import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { FocusVisibleManager } from "use-focus-visible";
import { noop } from "../../use-calendar/helpers";
import { StyledMultiDateWrapper, Input } from "../input";
export const MultipleDateInput = ({ autoFocus, dateInputs, required, }) => {
    const refs = useRef({});
    return (_jsx(StyledMultiDateWrapper, { children: _jsx(FocusVisibleManager, { children: dateInputs.map((props, i) => (_jsx(Input, Object.assign({ onValueChange: (changedValue) => {
                    const isFilledOut = changedValue.value.length === props.mask.length;
                    const nextField = refs.current[i + 1];
                    if (autoFocus && isFilledOut && nextField) {
                        setTimeout(() => {
                            nextField.focus();
                            nextField.select();
                        }, 100);
                    }
                }, getReference: (ref) => {
                    refs.current = Object.assign(Object.assign({}, refs.current), { [String(i)]: ref });
                }, onFocus: props.onFocus || noop, onBlur: props.onBlur || noop, required: required }, props), props.label))) }) }));
};
